/* One label renderer used by individual labels and combined print documents. */
(() => {
  'use strict';
  // Shopify's own locale-aware `product.url` returns "/en/products/handle" (etc.) on a published
  // non-default locale, not just "/products/handle" — a genuine, correct Shopify URL, not a malformed
  // one (unlike the earlier root_url+literal-path concatenation bug elsewhere). An optional short
  // locale segment (2 letters, optional "-XX" region) is accepted before "products/"; hostname+https
  // is still required to be an EXACT match, so this only ever widens which PATH on the SAME store is
  // accepted — never opens the door to a different host, scheme, or unrelated route.
  const PRODUCT_PATH_RE = /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\//;
  function fitText(node, minimum) {
    if (!node) return;
    let size = parseFloat(getComputedStyle(node).fontSize);
    while (node.scrollWidth > node.clientWidth + 1 && size > minimum) {
      size -= 0.5;
      node.style.fontSize = `${size}px`;
    }
  }
  function fits(label, options) {
    const content = label.querySelector('.label-content');
    const title = label.querySelector('.label-title');
    fitText(label.querySelector('.label-maker-name'), 6.5);
    // 2026-10-08: long Размер/Пакет text (profiles, skirting) shrinks until nothing is clipped; first down to
    // today's size (--package-size-before), then on to a 6pt (8px) floor; Артикул/Код shrinks with it so all three captions stay equal. Reset first so a re-run starts from the CSS size.
    const packageData = label.querySelector('.label-package-data');
    if (packageData) {
      const skuLine = label.querySelector('.label-sku');
      packageData.style.fontSize = '';
      if (skuLine) skuLine.style.fontSize = '';
      const before = parseFloat(getComputedStyle(packageData).getPropertyValue('--package-size-before')) * 4 / 3;
      let packageSize = parseFloat(getComputedStyle(packageData).fontSize);
      while ([...packageData.children].some(node => node.scrollWidth > node.clientWidth) && packageSize > 8) {
        let next = Math.max(8, packageSize - 0.5);
        if (before < packageSize && next < before) next = before;
        packageSize = next;
        packageData.style.fontSize = `${packageSize}px`;
        if (skuLine) skuLine.style.fontSize = `${packageSize}px`;
      }
    }
    let size = parseFloat(getComputedStyle(title).fontSize);
    while ((title.scrollHeight > title.clientHeight + 1 || title.scrollWidth > title.clientWidth + 1) && size > Number(options.titleMin || 15)) {
      size = Math.max(Number(options.titleMin || 15), size - 0.5);
      title.style.fontSize = `${size}px`;
    }
    const price = label.querySelector('.label-price');
    fitText(price, 27);
    return content.scrollHeight <= content.clientHeight + 1 &&
      [...label.querySelectorAll('.label-title,.label-maker,.label-identifiers,.label-variant,.label-specs,[data-label-fit]')].every(node => node.scrollHeight <= node.clientHeight + 1) &&
      [...label.querySelectorAll('.label-title,.label-variant,.label-maker,.label-sku,.label-price,.label-price-caption,.label-specs,.label-deadline,.label-footer,[data-label-fit]')]
        .every(node => node.scrollWidth <= node.clientWidth + 1);
  }
  async function prepare(label, options) {
      const slot = label.querySelector('.label-qr');
      const destination = new URL(slot.dataset.url);
      // The printed QR never inherits view, preview_theme_id, or tracking params.
      if (destination.protocol !== 'https:' || destination.hostname !== options.domain || !PRODUCT_PATH_RE.test(destination.pathname)) {
        throw new Error('Адресът на продукта не е валиден.');
      }
      const variant = destination.searchParams.get('variant');
      destination.search = '';
      destination.hash = '';
      if (variant && /^\d+$/.test(variant)) destination.searchParams.set('variant', variant);
      // Unicode handles stay compact in the QR; browsers encode them on navigation.
      const payload = destination.origin + decodeURI(destination.pathname) + destination.search;
      qrcode.stringToBytes = qrcode.stringToBytesFuncs['UTF-8'];
      const qr = qrcode(0, 'M');
      qr.addData(payload, 'Byte');
      qr.make();
      if (25 / (qr.getModuleCount() + 8) < 0.3) throw new Error('Адресът е твърде дълъг за този QR размер. Нужен е по-голям етикет.');
      slot.innerHTML = qr.createSvgTag({cellSize: 4, margin: 16, scalable: true});
      slot.dataset.encodedUrl = payload;
      slot.querySelector('svg').setAttribute('aria-hidden', 'true');
      await Promise.all([
        document.fonts.load(`800 20px "${options.displayFont}"`, 'Настилка'),
        document.fonts.load(`600 12px "${options.bodyFont}"`, 'Дебелина'),
        ...[...label.querySelectorAll('img')].map(img => img.decode())
      ]);
      await document.fonts.ready;
      if (!fits(label, options)) throw new Error('Текстът не се побира четливо. Нужна е корекция на етикета преди печат.');
  }
  window.ShopLabelRenderer=Object.freeze({prepare});
})();
